import { Link } from 'react-router-dom';

const Support = () => {
  return (
    <section className="headerBackground" style={{ fontFamily: 'Georgia, serif', backgroundColor: '#f4f4f9', padding: '20px' }}>
      <div
        className="space-ptb achievers-section"
        style={{
          border: '1px solid #ddd',
          borderRadius: '10px',
          padding: '40px',
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div style={{ marginTop: '30px', textAlign: 'center', color: '#333' }}>
          <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Contact Us</h3>
          <p style={{ marginBottom: '10px' }}>
            <strong>Email:</strong>{' '}
            <a href="mailto:admin@growniverse.com" style={{ color: '#007BFF', textDecoration: 'none' }}>
              admin@growniverse.com
            </a>
          </p>
          <p style={{ marginBottom: '30px' }}>
            <strong>WhatsApp:</strong>{' '}
            <a
              href="https://wa.me/+918091322146"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#007BFF', textDecoration: 'none' }}
            >
              Chat with us
            </a>
          </p>
          <ul
            style={{
              listStyleType: 'none',
              padding: '0',
              display: 'flex',
              justifyContent: 'center',
              gap: '15px',
            }}
          >
            <li>
              <a href="mailto:admin@growniverse.com" target="_blank" style={{ color: '#333', fontSize: '18px' }}>
                <i className="fa fa-envelope"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/growniverseofficial/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#C13584', fontSize: '18px' }}
              >
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a
                href="https://youtube.com/@growniverse?si=HipqeODMzh2ZDsLl"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#FF0000', fontSize: '18px' }}
              >
                <i className="fab fa-youtube"></i>
              </a>
            </li>
            <li>
              <a
                href="https://t.me/growniverse"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0088CC', fontSize: '18px' }}
              >
                <i className="fab fa-telegram"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61570584860719"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1877F2', fontSize: '18px' }}
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Support;